export type Appearance = "light" | "dark" | "system";
export const appearanceKey = "mira.appearance.v1";
export const appearanceEvent = "mira-appearance-change";

// Preserve brightness when restoring a color theme saved by an earlier version.
const legacySchemes = {
  claude: "light", xinhuang: "light", yanqing: "light", danxia: "light",
  hantan: "dark", wujin: "dark",
} as const;

export function parseAppearance(value: unknown): Appearance {
  if (value === "light" || value === "dark" || value === "system") return value;
  return typeof value === "string" && Object.hasOwn(legacySchemes, value)
    ? legacySchemes[value as keyof typeof legacySchemes] : "system";
}

export function resolveAppearance(value: Appearance, systemDark: boolean) {
  return { scheme: value === "system" ? systemDark ? "dark" : "light" : value };
}

export function setAppearance(value: Appearance, persist = true) {
  const resolved = resolveAppearance(value, window.matchMedia("(prefers-color-scheme: dark)").matches);
  const root = document.documentElement;
  root.dataset.appearance = value;
  root.dataset.theme = resolved.scheme;
  delete root.dataset.palette;
  if (persist) { try { localStorage.setItem(appearanceKey, value); } catch { /* Private mode still changes the current page. */ } }
  window.dispatchEvent(new Event(appearanceEvent));
}

// Runs before paint; legacy choices migrate without flashing their old palette.
export const appearanceBootstrap = `(()=>{let v="system";try{const s=localStorage.getItem(${JSON.stringify(appearanceKey)});const legacy=${JSON.stringify(legacySchemes)};v=["light","dark","system"].includes(s)?s:Object.hasOwn(legacy,s)?legacy[s]:"system";if(s&&s!==v)localStorage.setItem(${JSON.stringify(appearanceKey)},v)}catch{}const d=document.documentElement;d.dataset.appearance=v;d.dataset.theme=v==="system"?(matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light"):v;delete d.dataset.palette;})()`;
